export default __webpack_public_path__ + "static/media/hht1_wordplay.35c74127.png";